module.exports = __webpack_public_path__ + "media/images/file-0f9f68de0a30c8836bb64db898969b82.png";